import { render, staticRenderFns } from "./UserManagerEditTabSocial.vue?vue&type=template&id=5689cc50"
import script from "./UserManagerEditTabSocial.vue?vue&type=script&lang=js"
export * from "./UserManagerEditTabSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports